import { all, call, put, takeEvery } from 'redux-saga/effects'
import { actions as relatedReportsActions } from './RelatedReportsSlice'

function* relatedReportsRequest(services, { payload }) {
  const { tags, OnRequestSuccess } = payload
  const StoriesRepository = services('StoriesRepository')

  try {
    const data = yield call([StoriesRepository, 'getRelatedReportsByTags'], {
      tags
    })
    yield put(
      relatedReportsActions.requestRelatedReportsSuccess(data?.articles)
    )

    if (typeof OnRequestSuccess === 'function') {
      yield call(OnRequestSuccess, data?.articles)
    }
  } catch (e) {
    console.log(e)
    yield put(relatedReportsActions.requestRelatedReportsFailed(e.message))
  }
}

export default function* watchRelatedReports(services) {
  yield all([
    takeEvery(
      relatedReportsActions.requestRelatedReports,
      relatedReportsRequest,
      services
    )
  ])
}
